import React from 'react'

const EventDetail = () => {
  return (
   <>
   
   </>
  )
}

export default EventDetail